import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const stations = [
    "Kalwa (W)", "Bhandup (W)", "Chembur (E)", "Panvel — Pf. 7 (W)",
    "Naigaon — Pf. 1 (W)", "Ambernath (E)", "Andheri (W)", "Kandivali (W)",
    "Mira Road (E)", "Khar Road (E)", "Titwala (E)", "Palghar (W)",
    "Bhandup Gadhav Naka (W)", "Kurla (E)", "Mankhurd — Pf. 1 (W)", "Grant Road (W)",
    "Virar (W)", "Ulhasnagar (E)", "Malad (W)", "Dahisar (E)",
    "Bhayander (E)", "Dombivli — Pf. 1 (W)", "Nalasopara (W)", "Kasara (W)",
    "Murbad (E)", "Thane — Pf. 2 (W)", "Diva (E)", "Kalyan (W)",
    "Indiranagar Thane (E)", "Badlapur (E)", "Badlapur (W)", "Bhaskar Nagar Kalwa (E)",
    "Worli (W)",
];

const Locations = () => {
    return (
        <section
            id="locations"
            data-testid="locations-section"
            className="relative py-24 md:py-32 lg:py-40 bg-cream border-y border-ink-900/8"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-8">
                    <div className="col-span-12 lg:col-span-4">
                        <div className="section-number">07 / Footprint</div>
                        <div className="mt-6 divider" />
                        <div className="mt-4 eyebrow">33 Locations · Mumbai</div>
                    </div>
                    <div className="col-span-12 lg:col-span-8">
                        <motion.h2
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                            className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-ink-900 max-w-3xl"
                        >
                            A map of the city, <em className="text-bisleri">redrawn one
                            platform at a time.</em>
                        </motion.h2>
                        <p className="mt-6 font-body text-base md:text-lg text-ink-700 max-w-2xl leading-relaxed">
                            From the Western suburbs to the Trans-Harbour, the One Rupee
                            Clinic network now sits inside the bone of Mumbai's commute —
                            ready for the next emergency, the next consultation, the next
                            life.
                        </p>
                    </div>
                </div>

                <div className="mt-16 md:mt-20 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-3 bg-paper-50 border border-ink-900/10 p-6 md:p-10">
                    {stations.map((s, i) => (
                        <motion.div
                            key={s}
                            initial={{ opacity: 0, y: 10 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.6, delay: i * 0.02, ease: "easeOut" }}
                            className="group flex items-baseline gap-3 py-3 border-b border-ink-900/8 hover:border-bisleri/40 transition-colors"
                            data-testid={`location-${i}`}
                        >
                            <span className="font-mono text-[10px] text-ink-500 group-hover:text-bisleri transition-colors">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <MapPin size={12} className="text-clinicgreen-deep group-hover:text-bisleri transition-colors" />
                            <span className="font-display text-base md:text-lg text-ink-900 leading-tight">
                                {s}
                            </span>
                        </motion.div>
                    ))}
                </div>

                <div className="mt-8 font-body text-sm text-ink-600">
                    ↳ Each clinic operates 24×7 alongside a discount pharmacy. Coverage
                    continues to expand across Central, Western and Harbour railway lines.
                </div>
            </div>
        </section>
    );
};

export default Locations;
